module.exports = __webpack_public_path__ + "img/质量服务.845241de.jpg";